import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {APP_CONFIG} from './configService';

@Injectable({ providedIn: 'root' })
export class ThemeService {

  themes = {};
  logo = 'cookie.png';
  logoSubscription = new EventEmitter<string>();

  constructor(private http: HttpClient) {
  }

  load(brand: string): void {
    this.http.get(APP_CONFIG.rootConfig + APP_CONFIG.configFolder + 'themes.json', {
      headers: new HttpHeaders({
        'Cache-Control':  'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
        Pragma: 'no-cache',
        Expires: '0'
      })
    }).subscribe( (theme: any) => {
      this.themes = theme;
      this.use(brand);
    });
  }

  use(themeName = 'default'): void {
    // @ts-ignore
    if (!this.themes[themeName] ) {
      themeName = 'default';
    }
    // @ts-ignore
    this.setTheme( this.themes[themeName] );
  }

  private setTheme(theme: any): void {
    this.logo = theme.logo;
    this.logoSubscription.emit(theme.logo);
    Object.keys(theme).forEach(k =>
      document.documentElement.style.setProperty(`--${k}`, theme[k])
    );
  }

  getLogo(): string {
    return this.logo;
  }
}
